import "../scss/app.scss";
import { popper } from "@popperjs/core";
import { ScrollSpy, Tooltip, Dropdown, Popover, Collapse, Modal } from "bootstrap";
import Flickity from "flickity";
import AOS from "aos";
import GLightbox from "glightbox";


/* include navigation setup */
import "./inc/navigation.js";
import jquery from 'jquery';
window.jQuery = jquery;
import select2 from 'select2';
//import "./inc/leaflet.js";

//console.log('29-08-2023 16:25');

(function (window, document, $, undefined) {
	"use strict";
	$(function () {
		$(document).ready(function () {

			// Binding to trigger checkPasswordStrength
			$("body").on(
				"keyup",
				"input[name=password], input[name=password_retyped]",
				function (event) {
					checkPasswordStrength(
						$("input[name=password]"), // First password field
						$("input[name=password_retyped]"), // Second password field
						$("#password-strength"), // Strength meter
						$("input[type=submit]"), // Submit button
						["black", "listed", "word"] // Blacklisted words
					);
				}
			);

			/* DATABASE FORM INIT */
			$("#invitro_check, #invivo_check").on("click", function () {
				if ($(this).val() == "invivo") {
					$(".torganselect").css("display", "block");
					$(".cellselect").css("display", "none");
				} else {
					$(".torganselect").css("display", "none");
					$(".cellselect").css("display", "block");
				}
			});
			$("#invitro_check, #invivo_check").each(function () {
				if ($(this).prop("checked") == true) {
					$(this).trigger("click");
				}
			});
			$("#dborderby").on("change", function () {
				document.location = $(this)
					.find("option:selected")
					.attr("data-target");
			});
			$(".selectpicker").each(function () {
				$(this).select2({
					theme: "bootstrap-5",
					width: "100%",
					placeholder: $(this).data("placeholder"),
					allowClear: Boolean($(this).data("allow-clear")),
					dropdownCssClass: "select2--small",
					dropdownParent: $(this).parent(),
				});
			});

			/*$("select.form-control").each(function () {
				$(this).select2({
					theme: "bootstrap-5",
					width: "100%",
					placeholder: $(this).data("placeholder"),
					allowClear: Boolean($(this).data("allow-clear")),
					dropdownCssClass: "select2--small",
					dropdownParent: $(this).parent(),
				});
			});*/

			$("#db_multipage_select").on("change", function () {
				document.location = $(this).val();
			});

			$("#dbexport_link").on("click", function () {
				$("#db_export_form").attr("action", window.location);
				$("#db_export_form .hidden_container").html("");

				var url = window.location.search;
				var params = new URLSearchParams(url);
				params.forEach(function (value, key) {
					$("#db_export_form .hidden_container").append(
						'<input type="hidden" name="' +
						key +
						'" value="' +
						value +
						'" />'
					);
				});
				$("#db_export_form .hidden_container").append(
					'<input type="hidden" name="pdb_export" value="true" />'
				);
			});

			$('#dbexport_modal button[type="submit"]').on("click", function () {
				$("#dbexport_modal").modal("hide");
			});


			$('.prdliterature_filter').on('change', function () {
				var parent = $(this).parents('.container');
				if ($(this).val() == 'all') {
					parent.find('.pl_prd_content').fadeIn(200);
				} else {
					parent.find('.pl_prd_content').fadeOut(200);
					setTimeout(function (parent, val) { parent.find('.prd-' + val).fadeIn(200) }, 200, parent, $(this).val());
				}
			});

			$('.offers_section .filters select').on('change', function () {
				var section = $(this).parents('.offers_section');
				var type = section.find('select.filter-types').val();
				var location = section.find('select.filter-locations').val();
				console.log(type, location);
				if (type == 'all' && location != 'all') {
					section.find('.offer_wrapper').hide();
					section.find('.offer_wrapper.' + location).fadeIn(200);
				} else if (type != 'all' && location == 'all') {
					section.find('.offer_wrapper').hide();
					section.find('.offer_wrapper.' + type).fadeIn(200);
				} else if (type != 'all' && location != 'all') {
					section.find('.offer_wrapper').hide();
					section.find('.offer_wrapper.' + type + '.' + location).fadeIn(200);
				} else {
					section.find('.offer_wrapper').fadeIn(200);
				}
			});

			$('[href="#order"]').on('click', function () {
				var myModal = new Modal(document.getElementById('requestQuote')).show();
				//$("#requestQuote").modal("show");
			});

			var resizeFCRMIframes = function () {
				$("iframe[data-autoajust=true]").each(function () {
					$(this).css(
						"height",
						this.contentDocument.body.scrollHeight
					);
				});
			};
			if ($("iframe[data-autoajust=true]").length > 0) {
				$(document).on("shown.bs.modal", ".modal", resizeFCRMIframes);
				$(document).on("resize", resizeFCRMIframes);
				$("iframe[data-autoajust=true]").on("load", resizeFCRMIframes);
			}

			/* ORDER INFO */
			if ($(".orderinfo").length > 0) {
				$(".distributor_select").val("");
				$(".distributor_select option").each(function () {
					if (
						$(this).attr("value") != "" &&
						$(".distributor." + $(this).attr("value")).length == 0
					) {
						$(this).remove();
					}
				});
				$(".distributor_select").on("change", function () {
					var val = $(this).val();
					$(".distributor").hide();
	
					if ($(".distributor." + val).length > 1) {
						$(".local_distrib_info .plural").show();
					} else {
						$(".local_distrib_info .plural").hide();
					}
	
					if (val == "other" || val == "") {
						$(".local_distrib_info").fadeOut("fast");
					} else {
						$(".local_distrib_info").fadeIn("fast");
					}
	
					if ($(".distributor." + $(this).val()).length > 0) {
						$(".distributor." + $(this).val()).fadeIn("fast");
					}
				});
			}

			if ($("#new_password").length > 0) {
				var setPWDAreaState = function (state) {
					console.log(state);
					if (state) {
						var min = Array(4)
							.fill("abcdefghijkmnpqrstuvwxyz")
							.map(function (x) {
								return x[Math.floor(Math.random() * x.length)];
							});
						var maj = Array(4)
							.fill("ABCDEFGHJKLMNPQRSTUVWXYZ")
							.map(function (x) {
								return x[Math.floor(Math.random() * x.length)];
							});
						var chi = Array(3)
							.fill("123456789")
							.map(function (x) {
								return x[Math.floor(Math.random() * x.length)];
							});
						var car = Array(1)
							.fill("#?!@$%^&*")
							.map(function (x) {
								return x[Math.floor(Math.random() * x.length)];
							});
						var randPassword = min.concat(maj);
						randPassword = randPassword.concat(chi);
						randPassword = randPassword.concat(car);
						randPassword.sort(function () {
							return 0.5 - Math.random();
						});
						$("#password_field_area").slideDown(300);
						$("#user_password")
							.removeAttr("readonly")
							.val(randPassword.join(""));
					} else {
						$("#password_field_area").slideUp(300);
						$("#user_password").attr("readonly", true);
					}
				};
				$("#new_password").on("change", function () {
					setPWDAreaState($(this).prop("checked"));
				});
				setPWDAreaState($("#new_password").prop("checked"));
			}

			$("#prd_ordrer_select").on("change", function () {
				var root = $(this).parent();
				if (root.find("iframe").length > 0) {
					root.find("iframe").remove();
				}
				if ($(this).val() != "") {
					$("#iframe_loader").fadeIn(300);
					var ifr = $("<iframe/>", {
						id: "general_order_iframe",
						src: $(this).val(),
						style: "display:none;width:100%;height:1500px",
						frameborder: "0",
						allowfullscreen: "0",
						onload:
							"jQuery('#iframe_loader').fadeOut(300);jQuery(this).fadeIn(300);",
					});
					root.append(ifr);
				}
			});

		});
	});
})(window, document, window.jQuery);

var resizeIframe = function (obj) {
	/*jQuery(document).ready(function ($) {
		$("#iframe_loader").fadeOut(300);
		$(this).fadeIn(300);
		$(obj).animate(
			{ height: obj.contentWindow.document.body.scrollHeight + "px" },
			500
		);
	});*/
};

function checkPasswordStrength(
	$pass1,
	$pass2,
	$strengthResult,
	$submitButton,
	blacklistArray
) {
	var pass1 = $pass1.val();
	var pass2 = $pass2.val();

	// Reset the form & meter
	$submitButton.attr("disabled", "disabled");
	$strengthResult.removeClass("short bad good strong");

	// Extend our blacklist array with those from the inputs & site data
	blacklistArray = blacklistArray.concat(
		wp.passwordStrength.userInputBlacklist()
	);

	// Get the password strength
	var strength = wp.passwordStrength.meter(pass1, blacklistArray, pass2);

	// Add the strength meter results
	switch (strength) {
		case 2:
			$strengthResult.addClass("bad").html('This password is ' + pwsL10n.bad + ', please enter a stronger password in order to create your account.');
			break;
		case 3:
			$strengthResult.addClass("bad").html('This password is ' + pwsL10n.bad + ', please enter a stronger password in order to create your account.');
			break;
		case 4:
			$strengthResult.addClass("strong").html('This password is strong. That\'s ok !');
			break;
		case 5:
			$strengthResult.addClass("short").html('This password mismatch the password retyped.<br/>Please correct this in order to create your account.');
			break;
		default:
			$strengthResult.addClass("short").html('This password is very weak, please enter a stronger password in order to create your account.');
	}

	// The meter function returns a result even if pass2 is empty,
	// enable only the submit button if the password is strong and
	// both passwords are filled up
	if (4 === strength && "" !== pass2.trim()) {
		$submitButton.removeAttr("disabled");
	}

	return strength;
}


document.addEventListener("DOMContentLoaded", function () {
	var scrollHandler = function () {
		if (window.scrollY === 0) {
			document.body.classList.add("is-scroll-top");
		} else {
			document.body.classList.remove("is-scroll-top");
		}
		if (window.scrollY > 500) {
			document.body.classList.add("far-away");
		} else {
			document.body.classList.remove("far-away");
		}
	};
	window.addEventListener("scroll", scrollHandler);
	window.dispatchEvent(new Event("scroll"));

	/* MENU */

	//if (document.getElementById('menu_btn').length == 1) {
	document
		.getElementById('menu_btn')
		.addEventListener("click", function (event) {
			document.body.classList.toggle("menu_active");
		});
	//}
	document
		.getElementById("close_menu_btn")
		.addEventListener("click", function (event) {
			document.body.classList.toggle("menu_active");
		});

	var menu_links = document.querySelectorAll(
		".main-menu > ul > li.menu-item-has-children > a"
	);
	for (const menu_item of menu_links) {
		menu_item.addEventListener("click", (e) => {
			e.preventDefault();
			e.stopPropagation();
			var current = document.querySelector('.main-menu .selected');
			if (current && window.innerWidth >= 992) {
				current.classList.remove('selected');
			}
			menu_item.parentNode.classList.toggle("selected");
			var activerub = document.querySelector('.main-menu > ul > li.selected');
			if (activerub) {
				var currentSubMenu = document.querySelector('.main-menu > ul > li.selected > .sub-menu > li:first-child');
				currentSubMenu.classList.add('activerub');
				document.querySelector("body").classList.add("menu_active");

				var activeMainMenu = document.querySelector('.main-menu > ul > li.selected > .sub-menu');
				var menuHeight = 120;
				var minMenuHeight = activeMainMenu.offsetHeight;
				var activeMenu = currentSubMenu.querySelector('.sub-menu');
				if (activeMenu) {
					menuHeight = (menuHeight < minMenuHeight) ? minMenuHeight : activeMenu.offsetHeight;
					document.querySelector(".main-menu > ul > li.selected > .sub-menu").style.cssText = '--submenuHeight:' + menuHeight + 'px';
					triggerEvent(currentSubMenu, 'mouseover');
				}

				/*
				var activeMenu = document.querySelectorAll('.main-menu > ul > li.selected > .sub-menu > li > .sub-menu');
				var menuHeight = 120;
				for (var submenu of activeMenu) {
					console.log(submenu.offsetHeight);
					menuHeight = (menuHeight < 120) ? 120 : submenu.offsetHeight;
				}
				document.querySelector(".main-menu > ul > li.selected > .sub-menu").style.cssText = '--submenuHeight:' + menuHeight + 'px';
				*/

				/*
				var activeMenu = document.querySelector('.main-menu > ul > li.selected > .sub-menu > li > .sub-menu');
				if (activeMenu) {
					var menuHeight = (menuHeight < 120) ? 120 : activeMenu.offsetHeight;
					document.querySelector(".main-menu > ul > li.selected > .sub-menu").style.cssText = '--submenuHeight:' + menuHeight + 'px';
				}
				*/

			} else {
				if (window.innerWidth >= 992) {
					document.querySelector("body").classList.remove("menu_active");
				}
			}
			return false;
		});
	}

	document.querySelector(".ld-modal").addEventListener("click", function () {
		for (const menu_item of menu_links) {
			menu_item.parentNode.classList.remove("selected");
		}
		document.querySelector("body").classList.remove("menu_active");
	});

	var menu_sublinks = document.querySelectorAll(
		".main-menu > ul > li.menu-item-has-children > .sub-menu > li.menu-item-has-children > a"
	);
	for (const menu_item of menu_sublinks) {

		/*menu_item.parentNode.addEventListener("click", (e) => {
			document.querySelector(".main-menu > ul > li.selected > .sub-menu > li:first-child").classList.remove('activerub');
			menu_item.parentNode.classList.add("activerub");
			var menuHeight = menu_item.parentNode.querySelector('.sub-menu').offsetHeight;

			var leftMenu = menu_item.parentNode.parentNode.childElementCount;
			if (menuHeight < leftMenu * 59) {
				menuHeight = leftMenu * 59;
			}
			console.log(menuHeight);
			document.querySelector(".main-menu > ul > li.selected > .sub-menu").style.cssText = '--submenuHeight:' + menuHeight + 'px';
		});*/
		menu_item.parentNode.addEventListener("mouseover", (e) => {
			document.querySelector(".main-menu > ul > li.selected > .sub-menu > li:first-child").classList.remove('activerub');
			menu_item.parentNode.classList.add("activerub");
			var menuHeight = menu_item.parentNode.querySelector('.sub-menu').offsetHeight;

			var leftMenu = menu_item.parentNode.parentNode.childElementCount;
			if (menuHeight < leftMenu * 59) {
				menuHeight = leftMenu * 59;
			}
			//console.log(menuHeight);
			document.querySelector(".main-menu > ul > li.selected > .sub-menu").style.cssText = '--submenuHeight:' + menuHeight + 'px';
		});
		
		menu_item.parentNode.addEventListener("mouseout", (e) => {
			menu_item.parentNode.classList.remove("activerub");
			var activeMenu = document.querySelector('.main-menu > ul > li.selected > .sub-menu > li > .sub-menu');
			if (activeMenu) {
				var menuHeight = (menuHeight < 120) ? 120 : activeMenu.offsetHeight;
				var leftMenu = menu_item.parentNode.parentNode.childElementCount;
				if (menuHeight < leftMenu * 59) {
					menuHeight = leftMenu * 59;
				}
				document.querySelector(".main-menu > ul > li.selected > .sub-menu").style.cssText = '--submenuHeight:' + menuHeight + 'px';
			}
		});

		menu_item.addEventListener("click", (e) => {
			e.preventDefault();
			e.stopPropagation();
			return false;
		});
	}

	/* FIN MENU */

	var iframes = document.querySelectorAll(".video-section iframe");
	for (const iframe of iframes) {
		console.log("ts0");
		iframe.parentNode.classList.add("ratio");
		iframe.parentNode.classList.add("ratio-16x9");
	}

	var galleryElems = document.querySelectorAll(".partner-slider");
	for (var i = 0, len = galleryElems.length; i < len; i++) {
		var galleryElem = galleryElems[i];
		new Flickity(galleryElem, {
			cellAlign: "left",
			contain: false,
			autoPlay: 2500,
			pageDots: false,
			groupCells: false,
			wrapAround: true,
		});
	}

	var galleryElems = document.querySelectorAll(".application-slider");
	for (var i = 0, len = galleryElems.length; i < len; i++) {
		var galleryElem = galleryElems[i];
		new Flickity(galleryElem, {
			cellAlign: "left",
			contain: false,
			autoPlay: true,
			pageDots: true,
			initialIndex: 0,
			groupCells: 1,
			prevNextButtons: false,
			wrapAround: true,
			adaptiveHeight: false
		});
	}
	var galleryElems = document.querySelectorAll(".article-slider");
	for (var i = 0, len = galleryElems.length; i < len; i++) {
		var galleryElem = galleryElems[i];
		new Flickity(galleryElem, {
			cellAlign: "left",
			contain: false,
			autoPlay: true,
			pageDots: true,
			initialIndex: 0,
			groupCells: 1,
			prevNextButtons: false,
			wrapAround: true,
			adaptiveHeight: false
		});
	}
	var articleSliderCards = document.querySelectorAll(".article-slider .flickity-cell");
	for (var i = 0, len = articleSliderCards.length; i < len; i++) {
		var galleryElem = articleSliderCards[i];
		galleryElem.cssText = 'height:90%';
	}


	var productsCarroussels = document.querySelectorAll(
		".produits_section .slider_container"
	);
	for (var i = 0, len = productsCarroussels.length; i < len; i++) {
		//var productsCarroussel = productsCarroussels[i];
		new Flickity(productsCarroussels[i], {
			cellAlign: "left",
			initialIndex: 0,
			//contain: true,
			autoPlay: false,
			pageDots: false,
			groupCells: 1,
		});
	}

	var tooltipTriggerList = [].slice.call(
		document.querySelectorAll('[data-bs-toggle="tooltip"]')
	);
	var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
		return new Tooltip(tooltipTriggerEl);
	});

	const popoverTriggerList = document.querySelectorAll('[data-bs-toggle="popover"]')
	const popoverList = [...popoverTriggerList].map(popoverTriggerEl => new Popover(popoverTriggerEl, {
		html: true,
		content: function () {
			var id = this.getAttribute("data-bs-popover-content");
			return document.getElementById(id).querySelector(".popover-body").innerHTML;
		},
		title: function () {
			var id = this.getAttribute("data-bs-popover-content");
			return document.getElementById(id).querySelector(".popover-heading").innerHTML;
		},
		trigger: 'focus'
	}))

	AOS.init({
		duration: 500,
		easing: "ease",
		once: true,
		//offset: 120,
	});

	const lightbox = GLightbox({
		touchNavigation: true,
		loop: true,
		autoplayVideos: true,
	});
	const lightbox_content = GLightbox({
		selector: ".gallery-item a, #primary .section.container p a > img",
		touchNavigation: true,
		loop: true,
		autoplayVideos: true,
	});
	var resizeEvent = function () {
		var headerb = document.querySelector('#masthead .nav-bar');
		var page = document.querySelector('#primary.site-main');
		page.setAttribute("style", "--headerHeight:" + headerb.offsetHeight + "px");
	}
	window.addEventListener(
		"resize",
		resizeEvent
	);
	resizeEvent();

});


var menu_links = document.querySelectorAll(
	"#primary-menu > li.menu-item-has-children > a"
);

for (const menu_item of menu_links) {
	menu_item.addEventListener("click", (e) => {
		menu_item.parentNode.classList.toggle("selected");
		let is_active = false;
		for (const main_item of menu_links) {
			if (menu_item != main_item) {
				main_item.parentNode.classList.remove("selected");
			}
			if (main_item.parentNode.classList.contains("selected")) {
				is_active = true;
			}
		}
		if (is_active) {
			document.querySelector("body").classList.add("menu_active");
		} else {
			if (
				!document
					.getElementById("site-navigation")
					.classList.contains("toggled")
			) {
				document.querySelector("body").classList.remove("menu_active");
			}
		}
		e.preventDefault();
		e.stopPropagation();
		return false;
	});
}

if (document.querySelector("#chapters:not(.static)")) {
	var scrollSpy1 = new ScrollSpy(document.body, {
		target: "#chapters",
		offset: 250,
	});
}
if (document.querySelector("#producttabs")) {
	var scrollSpy2 = new ScrollSpy(document.body, {
		target: "#producttabs",
		offset: 250,
	});
}

var chapter_selector = document.querySelector("#chapter_selector select");
if (chapter_selector) {
	chapter_selector.addEventListener("change", function () {
		var url = location.href;
		location.href = chapter_selector.value;
		history.replaceState(null, null, url);
	});
}

var application_selector = document.querySelector("#application_filter");
if (application_selector) {
	application_selector.addEventListener("change", function () {
		var url = location.href;
		location.href = application_selector.value;
		history.replaceState(null, null, url);
	});
}

var triggerEvent = function (elem, event) {
	var evt = new MouseEvent(event, {
		bubbles: true,
		cancelable: true,
		view: window,
	});
	var canceled = !elem.dispatchEvent(evt);
};
